import {atom, useAtomValue, useSetAtom} from 'jotai';
import {Dispatch, SetStateAction, useCallback} from 'react';

type HighlightLocation = [number, number] | undefined;

const highlightLocationAtom = atom<HighlightLocation>(undefined);

export function useHighlightLocation(): HighlightLocation {
    return useAtomValue(highlightLocationAtom);
}

export function useSetHighlightLocation(): Dispatch<SetStateAction<HighlightLocation>> {
    const setter = useSetAtom(highlightLocationAtom);
    return useCallback((s: SetStateAction<HighlightLocation>) => setter(s), [setter]);
}
